import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import de from "./locales/de/translation.json";
import en from "./locales/en/translation.json";
import pl from "./locales/pl/translation.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
      pl: { translation: pl },
    },
    fallbackLng: "de",
    supportedLngs: ["de", "en", "pl"],
    // Browser language detection order
    detection: {
      order: ["cookie", "localStorage", "navigator", "htmlTag"],
      lookupCookie: "huwnd_lang",
      lookupLocalStorage: "huwnd_lang",
      caches: ["cookie", "localStorage"],
      cookieMinutes: 60 * 24 * 365, // 1 year
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
